module.exports = __webpack_public_path__ + "static/media/pack-items-icon2.d45966be.png";